import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '@shared/shared.module';

import { SegmentDiscountsRoutingModule } from './segment-discounts-routing.module';
import { SegmentDiscountsComponent } from './segment-discounts/segment-discounts.component';
import { SegmentDiscountsEffects } from './store/segment-discounts.effects';
import { SegmentDiscountsFeature } from './store/segment-discounts.slice';

@NgModule({
  declarations: [SegmentDiscountsComponent],
  imports: [
    CommonModule,
    TranslateModule,
    SegmentDiscountsRoutingModule,
    SharedModule,
    StoreModule.forFeature(SegmentDiscountsFeature),
    EffectsModule.forFeature([SegmentDiscountsEffects]),
  ],
})
export class SegmentDiscountsModule {}
